module.exports = "https://cdn.realtymogul.com/static/media/HP_card_grand_dominion.45b62625.jpg";